import React, {Component} from 'react'
import * as colors from '../colors'
import {style, media, merge} from 'glamor'
import {TimelineMax, TweenMax} from 'gsap'
import Reveal from './Reveal'
import Label from './Label'
import {Link} from 'react-router'
const duration = 0.4
const ease = TweenMax.Cubic.easeInOut

export default class RevealThumb extends Component {


  render(){
    const {children, image = "http://placehold.it/600x370", title ='Peguinet', ...props} = this.props
    return (
      <Link
        to={this.props.to}
      >
        {
           ({isActive, location, href, onClick, transition})=>(
             <a
              href={href}
              onClick={onClick}
              {...props}
              {...merge(style({
                width: '100%',
                display: 'block',
                position: 'relative',
                overflow: 'hidden',
                marginBottom: '1.5rem',
                color: colors.white
              }), media('(min-width: 800px)',{
                // paddingRight: '1.5rem',
                // width: '50%'
                marginBottom: '2rem',
              }))}
            >
            <img
              {...style({
                display: 'block',
                width: '100%',
                transition: 'filter 0.2s ease-out'
              })}
              style={{
                filter: isActive ? 'none' : 'grayscale(100%) contrast(120%)',
                WebkitFilter: isActive ? 'none' : 'grayscale(100%) contrast(120%)'
              }}
              src={image}
            />
            <div
              {...style({
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom :0,
                zIndex: 1,
                background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.4) 100%)'
              })}
            />

            <div
              {...style({
                position: 'absolute',
                bottom: 0,
                left: 0,
                zIndex: 2,
                margin: '1rem'
              })}
            >
            <div
              {...style({
                margin: '0rem',
                lineHeight: '1.1',
                fontSize:'1.5rem',
              })}
            >
              {title}
            </div>
            </div>


             </a>

           )
        }
      </Link>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/ThumbProject.js
 **/